import React, {useRef} from 'react';
import {Button, Modal, PageHeader, Tag} from 'antd';
import {useParams} from 'react-router-dom';

import {DeleteOutlined, EditOutlined, UploadOutlined} from '@/icons';

import {PageGrid, RowAction} from '@/component';
import {deleteNews, getExtraNewsUrl} from './extra-news';
import ExtraNewsFormModal from './ExtraNewsFormModal';
import {formatLong} from '@/util/dateUtils';
import ExtraNewsDrawer from './ExtraNewsDrawer';
import useTitle from '@/hook/useTitle';

function ExtraNews() {
    const ExtraNewsFormModalRef = useRef();
    const PageGridRef = useRef();
    const ExtraNewsDrawerRef = useRef();

    const {appId} = useParams();
    useTitle('上传图文');

    function onAddClick() {
        ExtraNewsFormModalRef.current.showModal();
    }

    function onTitleClick(record) {
        return () => {
            ExtraNewsDrawerRef.current.show(record.id);
        };
    }

    function onModifyClick(record) {
        console.log(record);
        ExtraNewsFormModalRef.current.showModal(record.id);
    }

    function onDeleteClick(record) {
        console.log(record);
        Modal.confirm({
            title: '警告',
            content: `确定要删除「${record.title}」`,
            okButtonProps: {danger: true},
            onOk: () => {
                deleteNews(record.id).then(() => {
                    PageGridRef.current.refresh();
                });
            },
        });
    }

    const extra = (
        <Button type="primary" icon={<UploadOutlined />} onClick={onAddClick}>
            上传图文
        </Button>
    );

    const columns = [
        {
            dataIndex: 'title',
            title: '标题',
            render: (text, record) => {
                return <a onClick={onTitleClick(record)}>{text}</a>;
            },
        },
        {
            dataIndex: 'newsNum',
            title: '类型',
            render: text => {
                if (text === 1) {
                    return <Tag color="green">单图文</Tag>;
                }
                return <Tag color="magenta">多图文[{text}]</Tag>;
            },
        },
        {
            dataIndex: 'createTime',
            title: '创建时间',
            render: text => {
                return formatLong(text);
            },
        },
        {
            title: '操作',
            key: 'action',
            width: 150, // eslint-disable-next-line react/display-name
            render: (__, record) => {
                const actions = [
                    {
                        key: 'modify',
                        title: '修改',
                        icon: <EditOutlined />,
                        onClick: onModifyClick,
                    },
                    {
                        key: 'delete',
                        title: '删除',
                        icon: <DeleteOutlined />,
                        onClick: onDeleteClick,
                    },
                ];
                return <RowAction actions={actions} record={record} />;
            },
        },
    ];

    return (
        <PageHeader title={`上传图文`} extra={extra} style={{overflowY: 'auto'}}>
            <PageGrid ref={PageGridRef} columns={columns} url={getExtraNewsUrl(appId)} />

            <ExtraNewsFormModal ref={ExtraNewsFormModalRef} pageGridRef={PageGridRef} />
            <ExtraNewsDrawer ref={ExtraNewsDrawerRef} />
        </PageHeader>
    );
}

export default ExtraNews;
